module.exports = __webpack_public_path__ + "img/map-mb.468bc4e8.webp";